import * as path from 'node:path';
import type WebSocket from 'ws';
import { getBridgeRoot } from '../files/cwd/index.js';
import { scheduleInitialIndexBuilds } from '../files/watch-file-index.js';
import type { CliE2eeRuntime } from '../lib/e2ee/index.js';
import { PreviewEnvironmentManager } from '../preview-environments/preview-environment-manager.js';
import type { LogFn } from '../log.js';
import type { PreviewWorktreeManager } from '../worktrees/manager/preview-worktree-manager.js';
import type { BridgeIdentifyReportedPaths } from './bridge-connection-runtime-types.js';

export function createBridgePreviewStack(options: {
  getWs: () => WebSocket | null;
  log: LogFn;
  e2ee: CliE2eeRuntime | undefined;
  previewWorktreeManager: PreviewWorktreeManager;
  worktreesRootPath: string;
}): {
  previewEnvironmentManager: PreviewEnvironmentManager;
  scheduleInitialIndexBuildsOnce: () => void;
  identifyReportedPaths: BridgeIdentifyReportedPaths;
} {
  const previewEnvironmentManager = new PreviewEnvironmentManager({
    getWs: options.getWs,
    log: options.log,
    getBridgeRoot,
    e2ee: options.e2ee,
    getPreviewWorktreeParentPath: (environmentId) =>
      options.previewWorktreeManager.getPreviewParentPath(environmentId),
  });

  let initialIndexBuildsScheduled = false;
  const scheduleInitialIndexBuildsOnce = (): void => {
    if (initialIndexBuildsScheduled) return;
    initialIndexBuildsScheduled = true;
    scheduleInitialIndexBuilds(getBridgeRoot());
  };

  const identifyReportedPaths: BridgeIdentifyReportedPaths = {
    bridgeRootPath: path.resolve(getBridgeRoot()),
    worktreesRootPath: path.resolve(options.worktreesRootPath),
    localShortcutPort: 0,
    localShortcutToken: '',
  };

  return { previewEnvironmentManager, scheduleInitialIndexBuildsOnce, identifyReportedPaths };
}
